import { Expose } from 'class-transformer';

export default class BillingAccountLinkFormError {
  practice_id: string[] = []
  billing_account_id: string[] = []
  @Expose({ name: '_schema' }) schema: string[] = []
}